import React from 'react';
import { Box, BoxProps } from '@mui/material';

interface VeilStreamLogoProps extends Omit<BoxProps, 'component'> {
  size?: 'small' | 'medium' | 'large' | 'xlarge' | 'header';
  /** When 'icon', renders the square vs_white_transparent logo (e.g. for collapsed sidebar). */
  variant?: 'full' | 'icon';
}

const FULL_LOGO_SRC = '/logo/Logo-white-on-transparent.svg';
const ICON_LOGO_SRC = '/logo/vs_white_transparent.png';

const VeilStreamLogo: React.FC<VeilStreamLogoProps> = ({
  size = 'medium',
  variant = 'full',
  sx,
  ...props
}) => {
  const sizeMap = {
    small: { height: '30px', width: '96px' },
    medium: { height: '40px', width: '128px' },
    large: { height: '50px', width: '160px' },
    xlarge: { height: '60px', width: '192px' },
    header: { height: '60px', width: '130px' }
  };

  const selectedSize = sizeMap[size];
  const isIcon = variant === 'icon';
  const src = isIcon ? ICON_LOGO_SRC : FULL_LOGO_SRC;
  const dimensions = isIcon
    ? { height: '32px', width: '32px' }
    : { height: selectedSize.height, width: selectedSize.width };

  return (
    <Box
      component="img"
      src={src}
      alt="VeilStream Logo"
      onError={(e) => {
        if (isIcon) {
          (e.target as HTMLImageElement).src = FULL_LOGO_SRC;
        }
      }}
      sx={{
        ...dimensions,
        objectFit: 'contain',
        flexShrink: 0,
        ...sx
      }}
      {...props}
    />
  );
};

export default VeilStreamLogo;
